import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { useChartColors } from '../../hooks/useChartColors';

interface BarChartProps {
  data: { name: string; value: number }[];
  color?: string;
  height?: number;
}

export function BarChart({ data, color, height = 300 }: BarChartProps) {
  const colors = useChartColors();
  const barColor = color || colors.primary;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsBarChart data={data} layout="vertical">
        <CartesianGrid strokeDasharray="3 3" stroke={colors.grid} horizontal={false} />
        <XAxis
          type="number"
          stroke={colors.axis}
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          type="category"
          dataKey="name"
          stroke={colors.axis}
          fontSize={12}
          tickLine={false}
          axisLine={false}
          width={80}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: colors.tooltipBg,
            border: `1px solid ${colors.tooltipBorder}`,
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            color: colors.text,
          }}
          formatter={(value: number) => [value.toLocaleString(), 'Count']}
        />
        <Bar
          dataKey="value"
          fill={barColor}
          radius={[0, 4, 4, 0]}
          fillOpacity={0.85}
          animationDuration={750}
        />
      </RechartsBarChart>
    </ResponsiveContainer>
  );
}
